<ng-container *transloco="let t">
  <div class="p-grid p-fluid">
    <div class="p-col">
      <app-form-control
        [cid]="'country'"
        [control]="this.form.get('country')"
        [options]="optionsCountries"
        [optionLabel]="'country_name'"
        [dataKey]="'country_code'"
        [type]="'select'"
        [filter]="true"
        [showClear]="true"
        [label]="t('common.labels.country')"
        [edit]="edit"
        [basevalue]="countryName"
        (changed)="onCountryChanged()"
      ></app-form-control>
    </div>
    <div class="p-col" *ngIf="showTimezone === true">
      <app-form-control
        [cid]="'timezone'"
        [control]="this.form.get('timezone')"
        [options]="optionsTimezones"
        [optionLabel]="'zone_name'"
        [dataKey]="'zone_id'"
        [type]="'select'"
        [filter]="true"
        [showClear]="true"
        [label]="t('common.labels.timezone')"
        [edit]="edit"
        [basevalue]="timezone"
        (changed)="onTimezoneChanged()"
      ></app-form-control>
    </div>
  </div>
</ng-container>
